import { ChangeDetectionStrategy, Component, HostListener, inject, signal } from '@angular/core';
import { I18n, NgtGlobalThemeService } from '@corporate/ng-tebis-base-components';
import { LoginComponent } from './07_feature/login/login.component';
import { AuthService } from './01_core/auth/auth.service';
import { FlatLayoutComponent } from './05_layout/flat-layout/flat-layout.component';
import { TabService } from './05_layout/flat-layout/flat-tabs/tab.service';
import { TestingService } from './testing.service';
import { AssistantService } from './04_service/assistant/assistant.service';
import { MdiLayoutComponent } from './05_layout/mdi-layout/mdi-layout.component';

@Component({
  selector: 'tps-root',
  standalone: true,
  imports: [
    FlatLayoutComponent,
    MdiLayoutComponent,
    LoginComponent,
],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  title = 'SME Process Solution';
  i18n = inject<I18n>(I18n);
  tabService = inject(TabService);
  authService = inject(AuthService);
  globalThemeService = inject(NgtGlobalThemeService);
  assistantService = inject(AssistantService);

  testing = inject(TestingService);

  count = signal(0);

  constructor() {
    this.globalThemeService.setDarkMode();
  }
}
